export default "__VITE_ASSET__753008dc__"